import { Component, Element, h, Prop, State } from '@stencil/core';
import { Suggestion } from '../../types/videoPlayer';
import { applyTheme, getUserUUID } from '../utils/control-utils';

@Component({
  tag: 'spectatr-player-sdk',
  styleUrl: 'spectatr-player-sdk.css',
  shadow: true,
})
export class VideoWrapper {
  @Prop({ attribute: 'clientId' }) clientId: string;
  @Prop({ attribute: 'baseUrl' }) baseUrl?: string = 'https://media-ingestion.antino.ca';
  @Prop({ attribute: 'videoId' }) videoId?: string = '';
  @Prop({ attribute: 'userId' }) userId?: string = '';
  @Prop({ attribute: 'autoPlay' }) autoPlay?: boolean = false;
  @Prop({ attribute: 'showSuggestions' }) showSuggestions?: boolean = true;
  @Prop({ attribute: 'captureReaction' }) captureReaction?: boolean = true;
  @Prop({ attribute: 'theme' }) theme?: string = 'classic-youtube';

  @Element() host: HTMLElement;

  @State() _videoId: string;
  @State() _nextVideoId: string;
  @State() _clientId: string;
  @State() _userId: string;
  @State() _baseUrl: string;
  @State() _autoPlay: boolean;
  @State() _showSuggestions: boolean;
  @State() _captureReaction: boolean;
  @State() _theme: string;
  @State() isIframe: boolean = false;
  @State() suggestions: Suggestion[] = [];
  @State() suggestionsHeight: number = 0;

  componentWillLoad() {
    this.isIframe = window.self !== window.top;
    // Extract query parameters from the URL
    const queryParams = new URLSearchParams(window.location.search);

    // Override props with query params if they exist
    this._videoId = queryParams.get('videoId') || this.videoId;
    this._clientId = queryParams.get('clientId') || this.clientId;
    this._userId = getUserUUID(queryParams.get('userId') || this.userId);
    this._baseUrl = queryParams.get('baseUrl') || this.baseUrl;
    this._autoPlay = queryParams.get('autoPlay') ? queryParams.get('autoPlay') === 'true' : this.autoPlay;
    this._showSuggestions = queryParams.get('showSuggestions') ? queryParams.get('showSuggestions') === 'true' : this.showSuggestions;
    this._captureReaction = queryParams.get('captureReaction') ? queryParams.get('captureReaction') === 'true' : this.captureReaction;
    this._theme = queryParams.get('theme') ?? this.theme;
    const root = document.documentElement;
    applyTheme(this._theme, root);
  }

  private setPlayerHeight() {
    const videoContainer = this.host.shadowRoot.querySelector('video-player');
    if (!videoContainer) {
      return;
    }
    const videoPlayerShadowRoot = videoContainer.shadowRoot;
    if (!videoContainer) return;
    const videoElement = videoPlayerShadowRoot.querySelector('#spectart-video-player')?.clientHeight;
    const videoMetaElement = videoPlayerShadowRoot.querySelector('.video-info')?.clientHeight;
    this.suggestionsHeight = videoElement + (videoMetaElement ?? 10);
  }

  private setNextVideoId() {
    if (!this.suggestions.length) return;
    let idx = -1;
    idx = this.suggestions.findIndex(suggestion => suggestion.id === this._videoId);
    if (idx >= 0 && idx < this.suggestions.length - 1) {
      this._nextVideoId = this.suggestions[idx + 1].id;
    } else if (idx < 0) {
      this._nextVideoId = this.suggestions[0].id;
    }
  }

  private setVideoId = (videoId: string) => {
    if (!videoId) return;
    this._videoId = videoId;
    this.setNextVideoId();
    this.setPlayerHeight();
  };

  private setSuggestions = (suggestions: Suggestion[]) => {
    this.suggestions = suggestions;
    this.setPlayerHeight();
    this.setNextVideoId();
  };

  render() {
    if (!this._clientId) {
      console.error('Please provide client id to the player to proceed.');
      return;
    }
    return (
      <div class="video-wrapper-container">
        <video-player
          autoPlay={this._autoPlay}
          captureReaction={this._captureReaction}
          videoId={this._videoId}
          userId={this._userId}
          clientId={this._clientId}
          baseUrl={this._baseUrl}
          setVideoId={this.setVideoId}
          nextVideoId={this._nextVideoId}
        />
        {this._showSuggestions && (
          <video-suggestions
            baseUrl={this._baseUrl}
            height={this.suggestionsHeight}
            clientId={this._clientId}
            setSuggestions={this.setSuggestions}
            videoId={this._videoId}
            handlePlaySuggestion={this.setVideoId}
          />
        )}
      </div>
    );
  }
}

// listen to an iframe

{
  /* <body>
  <iframe id="player-iframe" src="player.html"></iframe>

  <script>
    const iframe = document.getElementById('player-iframe');
    
    // Handle messages from iframe
    window.addEventListener('message', (event) => {
      // Security check (recommended)
      // if (event.origin !== "https://your-player-domain.com") return;
      
      if (event.data.type === 'spectatr-player') {
        switch (event.data.event) {
          case 'play':
            console.log('Playback started');
            // Or call your onPlay callback
            if (window.onSpectatrPlay) window.onSpectatrPlay();
            break;
          case 'pause':
            console.log('Playback paused');
            break;
          case 'error':
            console.error('Player error:', event.data.data);
            break;
        }
      }
    });

    // Example of calling methods in iframe
    function playVideo() {
      const player = iframe.contentWindow.document.querySelector('spectatr-player');
      player.play();
    }
  </script>
</body> */
}
